<div class="material-datatables">
  <table [id]="table_id" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%" #childScrollElement (wheel)="stopPropagation($event)">
    <thead>
      <tr>

        <th class="disabled-sorting no-sort" style="width: 85px;">
          <b style="display: flex">
            <a class="btn btn-link btn-primary btn-just-icon" (click)="selectAll()">
              <i class="fa {{checkAll() ? 'fa-check-square' : 'fa-square-o'}}" aria-hidden="true"></i>
            </a>
            <a *ngIf="bulk.length > 0" class="btn btn-link btn-default btn-just-icon" title="Clean Selected" (click)="cleanBulk()">
              <i class="material-icons">cleaning_services</i>
            </a>
            </b>
          </th>

        <th class="order" (click)="sort('id')"> <i [ngStyle]="{'color':orderby === 'id' ? 'blue' : 'black' }" class="fa {{ sorting('id') }}"></i> &nbsp; <b>ID</b></th>
        <th class="order" (click)="sort('po')"> <i [ngStyle]="{'color':orderby === 'po' ? 'blue' : 'black' }" class="fa {{ sorting('po') }}"></i> &nbsp; <b>PO</b></th>
        <th class="order" (click)="sort('fechacreado')"> <i [ngStyle]="{'color':orderby === 'fechacreado' ? 'blue' : 'black' }" class="fa {{ sorting('fechacreado') }}"></i> &nbsp; <b>Accumulation Start Date</b></th>
        <th class="order" (click)="sort('category')"> <i [ngStyle]="{'color':orderby === 'category' ? 'blue' : 'black' }" class="fa {{ sorting('category') }}"></i> &nbsp; <b>Category</b></th>
        <th class="order" (click)="sort('type')"> <i [ngStyle]="{'color':orderby === 'type' ? 'blue' : 'black' }" class="fa {{ sorting('type') }}"></i> &nbsp; <b>Item Type</b></th>
        <th class="order" (click)="sort('LWH')"> <i [ngStyle]="{'color':orderby === 'LWH' ? 'blue' : 'black' }" class="fa {{ sorting('LWH') }}"></i> &nbsp; <b>Dimensions (LWH)</b></th>
        <th class="order" (click)="sort('tareweight')"> <i [ngStyle]="{'color':orderby === 'tareweight' ? 'blue' : 'black' }" class="fa {{ sorting('tareweight') }}"></i> &nbsp; <b>Tare Weight</b></th>
        <th class="order" (click)="sort('internallocation')"> <i [ngStyle]="{'color':orderby === 'internallocation' ? 'blue' : 'black' }" class="fa {{ sorting('internallocation') }}"></i> &nbsp; <b>Location</b></th>
        <!--<th class="order" (click)="sort('fechamodificado')"> <i [ngStyle]="{'color':orderby === 'fechamodificado' ? 'blue' : 'black' }" class="fa {{ sorting('fechamodificado') }}"></i> &nbsp; <b>Last update</b></th>-->
        <th class="order" (click)="sort('rep')"> <i [ngStyle]="{'color':orderby === 'rep' ? 'blue' : 'black' }" class="fa {{ sorting('rep') }}"></i> &nbsp; <b>Container Creator</b></th>
        <th class="text-right"><b>Actions</b></th>

      </tr>
    </thead>
    <tbody>
      <tr style="cursor: pointer;" *ngFor="let item of data; let j = index" (click)="unclick(j, item)" (dblclick)="saveEmit('showdetail', item.id)" [ngClass]="{'bg-lumin': selectrow === j}">

        <td style="width: 30px;">
          <a class="btn btn-link btn-info btn-just-icon" (click)="selectItem(item.id)">
            <i class="material-icons">{{check(item.id) ? 'check_box' : 'check_box_outline_blank'}}</i>
          </a>
        </td>
        <td>{{item.id}}</td>
        <td>{{item.potext}}</td>
        <td>{{item.fechaCreado.timestamp * 1000 | date: 'MM/dd/yyyy'}}</td>
        <td>{{item.categoryId.name}}</td>
        <td>{{item.item}}</td>
        <td>{{item.width}}x{{item.length}}x{{item.height}}</td>
        <td>{{item.tareWeight}} lbs</td>
        <td>
          <span *ngIf="item.internalLocation !== null">
            {{item.internalLocation.locationName}}:
            {{item.internalLocation.locationRow}} - {{item.internalLocation.locationBay}} -
            {{item.internalLocation.locationLevel}} - {{item.internalLocation.locationSection}}
          </span>
        </td>
        <!--<td>
          <span *ngIf="item.fechaModificado !== null">
          {{item.fechaModificado.timestamp * 1000 | date: 'MM/dd/yyyy'}}
        </span>
      </td>-->
      <td>{{item.rep !== null ? (item.rep.name + ' ' + item.rep.surname) : ''}}</td>

      <td class="text-right">
        <a class="btn btn-link btn-info btn-just-icon">
          <i class="material-icons emitir" id="showdetail-{{item.id}}">remove_red_eye</i>
        </a>
        <a class="btn btn-link btn-success btn-just-icon">
          <i class="material-icons emitir" id="ready-{{item.id}}">done_outline</i>
        </a>
        <a *ngIf="item.chatLogs" class="btn btn-link btn-warning btn-just-icon">
          <i class="material-icons emitir" id="chat-{{item.id}}">chat</i>
        </a>

        <i style="cursor: pointer;" class="material-icons emitir" id="print-{{item.id}}">
          local_printshop
        </i>
          <!-- <a class="btn btn-link btn-info btn-just-icon" (click)="showModal(item)"><i class="material-icons">remove_red_eye</i></a> -->
          <!--<a class="btn btn-link btn-danger btn-just-icon" (click)="saveEmit('delete', item.id, item)"><i class="material-icons">close</i></a>-->
      </td>
      </tr>
    </tbody>

  </table>
</div>


<style>
  .order {
    cursor: pointer;
  }
</style>